(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"]) return;
  try {
    
  $('.faq-title .title').on('click', function () {
    $this = $(this).parent().next('.faq-content');
    $('.faq-content').not($this).slideUp();
    $this.slideToggle();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-masonry"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener("shopify:section:load", function(e){
    console.log("loaded")
    // init Masonry
    var $grid = $('.masonry-outer').packery({
      itemSelector: '.masonry-item',
      percentPosition: true
    });
    // layout Masonry after each image loads
    $grid.imagesLoaded().progress( function() {
      $grid.packery();
    });

    var videos = document.querySelectorAll('.masonry-outer video')
    for (var i = 0; i < videos.length; i++) {
      videos[i].addEventListener('loadedmetadata', function() {
        $grid.packery();
      })
    }
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-section-1-copy"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('shopify:section:load', function (e) {
      console.log('loaded');
      // init Masonry

      if (document.querySelector('.masonry-inner')) {
        var $grid = $('.masonry-inner').packery({
          itemSelector: '.masonry-item'
        });
        // layout Masonry after each image loads
        $grid.imagesLoaded().progress(function () {
          $grid.packery();
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-section-1"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('shopify:section:load', function (e) {
      console.log('loaded');
      // init Masonry

      if (document.querySelector('.masonry-inner')) {
        var $grid = $('.masonry-inner').packery({
          itemSelector: '.masonry-item'
        });
        // layout Masonry after each image loads
        $grid.imagesLoaded().progress(function () {
          $grid.packery();
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-section-2"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('shopify:section:load', function (e) {
      console.log('loaded');
      // init Masonry

      if (document.querySelector('.masonry-inner')) {
        var $grid = $('.masonry-inner').packery({
          itemSelector: '.masonry-item'
        });
        // layout Masonry after each image loads
        $grid.imagesLoaded().progress(function () {
          $grid.packery();
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-1"]) return;
  try {
    
  document.addEventListener('shopify:section:load', function (e) {
    console.log('loaded');
    // init Masonry
    var $grid = $('#masonry').packery({
      itemSelector: '.masonry-item'
    });
    // layout Masonry after each image loads
    $grid.imagesLoaded().progress(function () {
      $grid.packery();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-overlay"]) return;
  try {
    
  var mainContainer = document.querySelector('.main-wrap'),
    openCtrl = document.querySelector('.search-trigger'),
    closeCtrl = document.getElementById('btn-search-close'),
    searchContainer = document.querySelector('.search-overlay'),
    inputSearch = searchContainer.querySelector('.search__input'),
    body = document.querySelector('body'),
    form = searchContainer.querySelector('form');

  function init() {
    initEvents();
  }

  function initEvents() {
    openCtrl.addEventListener('click', openSearch);
    closeCtrl.addEventListener('click', closeSearch);
    document.addEventListener('keyup', function (ev) {
      // escape key.
      if (ev.keyCode == 27) {
        closeSearch();
      }
    });
  }

  function openSearch(e) {
    e.preventDefault();
    mainContainer.classList.add('main-wrap--move');
    searchContainer.classList.add('search--open');
    body.classList.add('no-scroll');
    setTimeout(function () {
      inputSearch.focus();
    }, 600);
  }

  function closeSearch() {
    mainContainer.classList.remove('main-wrap--move');
    searchContainer.classList.remove('search--open');
    body.classList.remove('no-scroll');
    inputSearch.blur();
    inputSearch.value = '';
  }

  init();

  } catch(e) { console.error(e); }
})();
})();
